// extracted by mini-css-extract-plugin
module.exports = {"nav":"Breadcrumbs-module__nav___1ELUO","seperator":"Breadcrumbs-module__seperator___1c-Vt"};